<template>
  <div>

    <modal name="cookie-modal" :scrollable="true" :adaptive="true" height="auto" :minWidth="300" :maxWidth="600"
      @closed="resetState">
      <div class="cookie-banner">
        <div class="cookie-banner__content">
          <h3 class="h h--3 h--dark cookie-banner__title">USTAWIENIA PLIKOW COOKIE</h3>
          <p class="paragraph mb-2">
            W naszych witrynach internetowych używamy różnych zastrzeżonych i zewnętrznych technologii internetowych, w
            tym Cookies, w celu zwiększenia komfortu korzystania z Internetu. Oprócz technologii internetowych, które
            zapewniają funkcjonalność stron internetowych, obejmuje to również technologie internetowe do anonimowych
            analiz internetowych i wyświetlania ukierunkowanych reklam. Ich użycie jest dobrowolne i wymaga Twojej
            zgody.
            W każdej chwili możesz odwołać swoją zgodę na przyszłość lub zmienić ustawienia w dowolnym momencie w sekcji
            „Zmień ustawienia Cookie ” lub bezpośrednio w swojej przeglądarce internetowej.
          </p>

          <p class="paragraph mt-2 mb-3">
            <a href="https://www.geberit.pl/meta-pl/m-data-privacy.html" target="_blank"
              class="cookie-banner__link">Polityka
              prywatności</a>

            | <a href="https://www.geberit.pl/meta-pl/m-impressum.html" target="_blank"
              class="cookie-banner__link">Informacja
              prawna</a>

            <span v-if="view === 'categories'">
              | <a class="cookie-banner__link" @click="view = 'services'">
                Szczegóły usług
              </a>
            </span>
          </p>

          <div v-if="view === 'categories'" class="cookie-banner__services">
            <div class="form__input-container" v-for="category in categories" :key="category.slug">
              <input type="checkbox" :id="`category-${category.slug}`" class="form__checkbox"
                @change="onToggleCategoryConsent(category.slug)" :checked="categoriesState[category.slug]"
                :disabled="category.required" />
              <label :for="`category-${category.slug}`"> <span v-text="category.name"></span> </label>
            </div>
          </div>

          <div v-if="view === 'services'" class="cookie-banner__services">
            <div class="cookie-banner__tabs">
              <button v-for="category in categories" :key="category.slug"
                :class="['cookie-banner__tab', { 'cookie-banner__tab--active': activeCategory === category.slug }]"
                @click="activeCategory = category.slug">
                {{ category.name }}
              </button>
            </div>
            <div class="form__input-container" v-for="service in filteredServices" :key="service.slug">
              <input type="checkbox" :id="`service-${service.slug}`" class="form__checkbox"
                @change="onToggleServiceConsent(service.slug)" :checked="consents[service.slug]"
                :disabled="categories.find(category => category.slug === service.category).required" />
              <label :for="`service-${service.slug}`">
                <span v-text="service.name"></span>
                <p class="paragraph" v-text="service.description"></p>
              </label>
            </div>
          </div>


          <div class="cookie-banner__button-container">
            <button class="cookie-banner__button" @click="denyAll()">
              Odrzuć wszystkie
            </button>
            <button class="cookie-banner__button cookie-banner__button--blue" @click="savePreferences()">
              Zapisz ustawienia
            </button>
          </div>
        </div>


      </div>
    </modal>

    <button class="floating-button js-consent-cookies-open" @click="openBanner()">
      <svg class="floating-button__icon" viewBox="0 0 512 512">
        <!-- Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. -->
        <path
          d="M510.4 254.8l-12.1-76.3a132.5 132.5 0 0 0 -37.2-73l-54.8-54.8c-19.7-19.7-45.2-32.7-72.7-37.1l-76.7-12.2c-27.5-4.4-55.7 .1-80.5 12.8L107.3 49.6a132.3 132.3 0 0 0 -57.8 57.8l-35.1 68.9a132.6 132.6 0 0 0 -12.8 80.9l12.1 76.3a132.5 132.5 0 0 0 37.2 73l54.8 54.8a132.1 132.1 0 0 0 72.7 37.1l76.7 12.1c27.5 4.4 55.7-.1 80.5-12.8l69.1-35.2a132.3 132.3 0 0 0 57.8-57.8l35.1-68.9c12.7-25 17.2-53.3 12.8-81zM176 368c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-160c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z" />
      </svg>
    </button>
  </div>

</template>

<script>
import Vue from 'vue'
export default {
  name: 'CookieBanner',
  data() {
    return {
      activeCategory: 'necessary',
      view: 'categories',
      categories: [
        {
          slug: 'necessary',
          name: 'Niezbędne',
          description: 'Niezbędne pliki cookie umożliwiają korzystanie z podstawowych funkcji witryny, takich jak strony internetowe i dostęp do zabezpieczonych obszarów witryny. Bez tych plików cookie witryna nie może działać poprawnie.',
          required: true
        },
        {
          slug: 'statistics',
          name: 'Statystyki',
          description: 'Statystyki plików cookie pomagają właścicielom witryn zrozumieć, w jaki sposób odwiedzający komunikują się z witrynami, zbierając i raportując informacje anonimowo.',
          required: false
        }
      ],
      services: [
        {
          slug: 'session-cookies',
          category: 'necessary',
          name: 'Pliki sesji',
          description: 'Pliki sesji są niezbędne do prawidłowego funkcjonowania witryny. Są one automatycznie usuwane po zakończeniu sesji.',
          cookies: ['api_token', 'geberit_pro_session'],
          gtagFields: []
        },
        {
          slug: 'xsrf-token',
          category: 'necessary',
          name: 'XSRF Token',
          description: 'XSRF Token to środek bezpieczeństwa chroniący przed atakami typu cross-site request forgery. Jest niezbędny do prawidłowego funkcjonowania witryny.',
          cookies: ['^XSRF-TOKEN'],
          gtagFields: []
        },
        {
          slug: 'google-analytics',
          category: 'statistics',
          name: 'Google Analytics',
          description: 'Google Analytics to usługa analizy internetowej firmy Google LLC, która umożliwia śledzenie i analizę ruchu na stronach internetowych. Dane są wykorzystywane do opracowywania raportów o działalności witryny.',
          cookies: ['^_ga', '^_gid', '^_gcl', 'FPID', 'FPLC'],
          gtagFields: ['analytics_storage']
        },
      ],
      consents: {}
    }
  },
  computed: {
    categoriesState() {
      return Object.fromEntries(this.categories.map(category => [category.slug, this.services
        .filter(service => service.category === category.slug)
        .some(service => this.consents[service.slug])]));
    },
    filteredServices() {
      return this.services.filter(service => service.category === this.activeCategory);
    }
  },
  methods: {
    onToggleCategoryConsent(categorySlug) {
      const categoryState = this.categoriesState[categorySlug];
      this.services
        .filter(service => service.category === categorySlug)
        .forEach(service => {
          this.consents[service.slug] = !categoryState;
        });
    },
    onToggleServiceConsent(serviceSlug) {
      this.consents[serviceSlug] = !this.consents[serviceSlug];
    },
    openBanner() {
      this.$modal.show('cookie-modal')
    },
    closeBanner() {
      this.$modal.hide('cookie-modal')
    },
    encodeObject(object = {}) {
      return `~cookie-banner-saved-data-v2~${JSON.stringify(object)}`
    },
    decodeObject(str = '') {
      if (typeof str !== 'string' || !str.includes('~cookie-banner-saved-data-v2~')) {
        return null
      }
      return JSON.parse(str.replace('~cookie-banner-saved-data-v2~', ''))
    },
    applyPreferences() {
      const consents = this.decodeObject(this.$cookies.get('cookie-consent')) || this.consents;

      const blockedCookies = this.decodeObject(this.$cookies.get('blocked_cookies')) || {};

      const cookiesToBlock = this.services
        .filter(service => !consents[service.slug])
        .flatMap(service => service.cookies);

      // block selected cookies
      const cookies = this.$cookies.keys();
      cookies.filter(cookie => cookiesToBlock
        .some(pattern => new RegExp(pattern).test(cookie)))
        .forEach((cookie) => {
          blockedCookies[cookie] = this.$cookies.get(cookie);
          this.$cookies.remove(cookie);
        });

      // restore previously deleted cookies
      Object.keys(blockedCookies)
        .filter((cookie) => cookiesToBlock.every(pattern => !new RegExp(pattern).test(cookie)))
        .forEach((cookie) => {
          this.$cookies.set(cookie, blockedCookies[cookie], -1)
          delete blockedCookies[cookie];
        });

      // save blocked cookies
      this.$cookies.set('blocked_cookies', this.encodeObject(blockedCookies), -1);

      const gtagConsent = this.services.reduce((acc, service) => {
        service.gtagFields.forEach(field => {
          acc[field] = consents[service.slug] ? 'granted' : 'denied';
        });
        return acc;
      }, {
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        ad_storage: 'denied',
        analytics_storage: 'denied',
      });

      // Update gtag consent
      this.$gtag.set(gtagConsent);
    },
    savePreferences() {
      this.$cookies.set('cookie-consent', this.encodeObject(this.consents), -1);
      this.applyPreferences();
      this.closeBanner();
    },
    denyAll() {
      this.consents = Object.fromEntries(this.services.map(service => {
        const serviceCategory = this.categories.find(category => category.slug === service.category);
        if (!serviceCategory || !serviceCategory.required) {
          return [service.slug, false];
        }
        return [service.slug, true];
      }));

      this.savePreferences();
    },
    allowAll() {
      this.consents = Object.fromEntries(this.services.map(service => [service.slug, true]));
      this.savePreferences();
    },
    resetState() {
      this.view = 'categories';
      this.activeCategory = 'necessary';
    }
  },
  mounted() {
    const consents = this.decodeObject(this.$cookies.get('cookie-consent'));

    if (!consents) {
      this.denyAll();
      this.openBanner();
    } else {
      this.consents = consents;
    }

    this.applyPreferences();

    window.addEventListener('load', this.applyPreferences);
  },

  destroyed() {
    window.removeEventListener('load', this.applyPreferences);
  }

}
</script>



// WEBPACK FOOTER //
// src/app/components/CookieBanner.vue